import { DIALOG_ACTIONS } from "./actions";

export interface IDialogState {
  isOpen: boolean;
  title: string;
}

const initialState: IDialogState = {
  isOpen: false,
  title: "",
};

export const dialogReducer = (state: IDialogState = initialState, action): IDialogState => {
  switch (action.type) {
    case DIALOG_ACTIONS.OPEN_DIALOG: {
      return {
        ...state,
        isOpen: true,
        title: action.payload,
      };
    }
    case DIALOG_ACTIONS.CLOSE_DIALOG: {
      return {
        ...state,
        isOpen: false,
        title: "",
      };
    }
    default:
      return state;
  }
};
